import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { Observable } from 'rxjs';

import { ModulesService } from '../../../shared/modules/modules.service';
import { moduleId } from '../../model/module-id';

@Injectable()
export class KitchenGuard implements CanActivate {
  constructor(private moduleService: ModulesService) {}

  public canActivate(): Observable<boolean> {
    return this.moduleService.isModuleEnabled(moduleId.KITCHEN);
  }
}
